export default "__VITE_ASSET__149357fe__"